import { styled, Box } from '@mui/material';

export const ActivityTimelineContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2.5),
  position: 'relative',
  width: '360px',
}));
